/**
 * Equijump Ltd. · Brands page - image fallback
 *
 * If a Shopify CDN image 404s or is yanked, the tile keeps its shape and the
 * brand name shows as a wordmark instead. Used by the brands page main cards
 * (aaa-brands-mains) and A-Z tiles (aaa-brands-atoz).
 *
 * Loaded via a manual <script defer> tag in sections/aaa-brands-atoz.liquid.
 */
(function () {
  'use strict';

  function clean(label) {
    return (label || '').replace(/^Shop |^See the | range$/g, '').trim();
  }

  function brandNameFor(img) {
    var tile = img.closest('.brand-tile');
    if (tile) return clean(tile.getAttribute('aria-label'));
    var card = img.closest('.brand-card');
    if (card) {
      var nameEl = card.querySelector('.brand-card-name');
      if (nameEl && nameEl.textContent.trim()) return nameEl.textContent.trim();
      return clean(card.getAttribute('aria-label'));
    }
    return img.alt || '';
  }

  function onImgError(e) {
    var img = e.target;
    if (img.dataset.brokenHandled) return;
    img.dataset.brokenHandled = '1';

    // A-Z tile cover image
    var tileWrap = img.closest('.brand-tile-img');
    if (tileWrap) {
      tileWrap.classList.add('is-broken');
      tileWrap.setAttribute('data-brand-name', brandNameFor(img));
      return;
    }

    // Main editorial card cover photo -> show the brand name as a wordmark
    if (img.classList.contains('photo')) {
      var cardWrap = img.closest('.brand-card-img');
      if (cardWrap) {
        cardWrap.classList.add('is-broken');
        cardWrap.setAttribute('data-brand-name', brandNameFor(img));
      } else {
        img.setAttribute('data-broken', '');
      }
      return;
    }

    // Main-card logo chip image -> hide so no broken-image icon shows
    if (img.closest('.brand-card-logo')) {
      img.style.display = 'none';
    }
  }

  document.addEventListener('error', function (e) {
    if (e.target && e.target.tagName === 'IMG') onImgError(e);
  }, true);
})();
